'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var isFunction = function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}; // Maybe this is not needed at all


var handleSingleVariableFor = function handleSingleVariableFor(variableDescriptor, value) {
  return _toConsumableArray(variableDescriptor.selector ? document.querySelectorAll(variableDescriptor.selector) : [document.documentElement]).map(function (el) {
    var actualValue = (variableDescriptor.type || '').indexOf('color') > -1 ? value[variableDescriptor.type === 'color' ? 'default' : variableDescriptor.type.split(':')[1]].color : variableDescriptor.extractValue ? variableDescriptor.extractValue(value) : value;

    if (actualValue && actualValue.indexOf('CT_CSS_SKIP_RULE') > -1) {
      el.style.removeProperty("--".concat(variableDescriptor.variable));
    } else {
      el.style.setProperty("--".concat(variableDescriptor.variable), "".concat(actualValue || '').concat(variableDescriptor.unit || ''));
    }
  });
};

var handleVariablesFor = function handleVariablesFor(variables) {
  return wp.customize.bind('change', function (e) {
    if (!variables[e.id]) {
      return;
    }

    var allVariables = variables[e.id];

    if (isFunction(allVariables)) {
      allVariables = allVariables(e());
    }

    if (!Array.isArray(allVariables)) {
      allVariables = [allVariables];
    }

    allVariables.map(function (d) {
      return handleSingleVariableFor(d, e());
    });
  });
};

exports.handleVariablesFor = handleVariablesFor;
//# sourceMappingURL=simplified.js.map
